module.exports = __webpack_public_path__ + "media/images/lb/526-b686742403726e5e966608ed4e0f7cd5.svg";